var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { mapGetters, mapActions } from 'vuex';
import { DISCOUNT, MENU_ITEMS, BUNDLE, MENU_OPTION_EXCEPTIONS } from '@/stores/defs';
import DiscountModel from '@/models/DiscountModel';
import { reduce, values } from 'lodash';
// TODO for mixins, get typescript definitions.
var discountMixin = {
    computed: __assign({}, mapGetters({
        getDiscountForItem: DISCOUNT.GET_FOR_ITEM,
        getDiscounts: DISCOUNT.GET_DISCOUNTS,
        getItem: MENU_ITEMS.GET_ITEM,
        getItemBundle: BUNDLE.ITEM,
        getBundleItems: BUNDLE.GET_ITEMS,
        getDiscountedPrice: DISCOUNT.CURRENT_DISCOUNTED_PRICE,
        getBasePriceForItem: DISCOUNT.GET_BASE_PRICE_FOR_ITEM,
        getOptionException: MENU_OPTION_EXCEPTIONS.GET_FOR_ITEM,
        menuId: MENU_ITEMS.GET_MENU_ID
    })),
    methods: __assign({}, mapActions({
        addDiscount: DISCOUNT.ADD_DISCOUNT,
        clearDiscounts: DISCOUNT.CLEAR_DISCOUNTS,
        setCurrentDiscountedPrice: DISCOUNT.SET_CURRENT_DISCOUNTED_PRICE,
        setBasePriceForItem: DISCOUNT.SET_BASE_PRICE_FOR_ITEM,
    }), { discountForItemMixin: function (item) {
            var bundle = this.getItemBundle;
            if (bundle) {
                return this.getDiscountForBundle(item);
            }
            return 0;
        },
        // TODO could be refactored in single getDiscount
        getDiscountForBundle: function (item) {
            var bundleItem = this.getItemBundle;
            var discount = bundleItem.discount;
            var uniqueId = "" + item.parentGroupId;
            var discountedPrice = 0;
            var delta = 0;
            switch (discount.type) {
                case 2 /* TARGET_PRICE */: {
                    var currentPrice = item.getItemTotal();
                    var itemPrice = item.price;
                    var basePrice = this.getBasePriceForItem(uniqueId) || itemPrice;
                    if (!basePrice) {
                        basePrice = currentPrice;
                    }
                    delta = currentPrice - basePrice;
                    this.addDiscount({
                        uniqueId: uniqueId,
                        amount: delta,
                    });
                    var targetPrice = discount.amount;
                    discountedPrice = targetPrice + this.getBundleTargetPriceDelta();
                }
            }
            return discountedPrice;
        },
        getBundleTargetPriceDelta: function () {
            // add discount to delta array
            var discountDeltas = values(this.getDiscounts);
            var deltaSum = reduce(discountDeltas, function (sum, delta) {
                return sum + delta;
            }, 0);
            return deltaSum;
        },
        createDiscount: function (amount, name, id) {
            var discountName = name || 'Discount';
            var discountId = id || 'custom';
            var discount = new DiscountModel({
                useHydrator: 'hydrateFromStore',
                type: 0 /* AMOUNT */,
                amount: amount,
                name: discountName,
                active: true,
                isOnline: true,
                maxRedemptions: 1,
                id: discountId,
                discount_id: discountId,
                menu_id: this.menuId
            });
            return discount;
        } }),
};
export default discountMixin;



//////////////////
// WEBPACK FOOTER
// ./src/components/mixins/discountMixin.ts
// module id = H0u0
// module chunks = 18